import Countdown from '@/components/Countdown'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: Countdown,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}